import { MouseEvent } from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { useTranslation } from 'react-i18next';

type RowActionsProps = {
  participantId: string;
  onEdit: (e: MouseEvent<unknown>) => void;
  onDelete: (e: MouseEvent<unknown>) => void;
  onTransfer?: (e: MouseEvent<unknown>) => void;
};

export function ParticipantRowActionsMenu({
  participantId,
  onEdit,
  onDelete,
  onTransfer,
}: RowActionsProps) {
  const { t } = useTranslation();
  const actionsMenu = usePopupState({ variant: 'popover', popupId: `participant-actions-${participantId}` });

  return (
    <>
      <IconButton
        size="small"
        {...bindTrigger(actionsMenu)}
        aria-label={t('participants.optionsLabel')}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu {...bindMenu(actionsMenu)}>
        {onTransfer && (
          <MenuItem
            onClick={e => {
              onTransfer(e);
              actionsMenu.close();
            }}
          >
            <ListItemIcon>
              <SwapHorizIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('participants.transfer')}</ListItemText>
          </MenuItem>
        )}
        <MenuItem
          onClick={e => {
            onEdit(e);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('participants.editParticipant')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={e => {
            onDelete(e);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <DeleteForeverIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('participants.deleteParticipant')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
